/**
 * Format a distance in meters to a human-readable string.
 * < 1000m → "X m"
 * >= 1000m → "X.XX km"
 */
export function formatDistance(meters: number): string {
  if (meters < 1000) {
    return `${Math.round(meters)} m`;
  }
  return `${(meters / 1000).toFixed(2)} km`;
}
